import { UPDATE_TRAIL } from './actions';

const initialState = {
  trail: [],
};

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  if (action.type === UPDATE_TRAIL) {
    return { ...state, trail: action.trail };
  }
  return state;
}

export default reducer;
